import { useEffect, useState } from 'react';

import dayjs, { extend } from 'dayjs';
import duration from 'dayjs/plugin/duration';

export const addSecond = (currDiffDate: number[] | null) => {
    if (currDiffDate) {
        let [days, hours, minutes, seconds] = currDiffDate;
        seconds += 1;

        if (seconds === 60) {
            minutes += 1;
            seconds = 0;
        }

        if (minutes === 60) {
            minutes = 0;
            hours += 1;
        }

        if (hours === 24) {
            hours = 0;
            days += 1;
        }
        return [days, hours, minutes, seconds];
    }
    return null;
};

export const formatDate = (diffDate: number[] | null) => {
    if (!diffDate) return null;
    const [days, hours, minutes, seconds] = diffDate;
    let formattedDate = '';
    if (days) {
        formattedDate += `${days}D `;
    }
    if (hours) {
        formattedDate += `${hours}H `;
    }
    if (minutes) {
        formattedDate += `${minutes}M `;
    }

    // it will always show seconds
    formattedDate += `${seconds}S `;

    return formattedDate;
};

extend(duration);
export const getDiff = (lastActivity?: string) => {
    if (!lastActivity) return null;

    const date = dayjs(new Date(lastActivity));
    const now = dayjs();

    const diff = dayjs.duration(now.diff(date));
    const diffFormatted = diff.format('D:H:mm:ss');
    return diffFormatted.split(':').map((val) => parseFloat(val));
};

export const useGetFormatDateDif = (lastActivity?: string) => {
    const [diffDate, setDiffDate] = useState<number[] | null>(getDiff(lastActivity));

    useEffect(() => {
        if (lastActivity && !diffDate) {
            setDiffDate(getDiff(lastActivity));
        }
        if (diffDate) {
            const timeout = setTimeout(() => {
                setDiffDate(addSecond);
            }, 1000);
            return () => clearTimeout(timeout);
        }
    }, [diffDate, lastActivity]);

    return formatDate(diffDate);
};
